// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__UCbUk","user":"navbar_user__im2FQ","data":"navbar_data__DU1YU","name":"navbar_name__iZiwe","company":"navbar_company__H1Upj","image":"navbar_image__1WayM"};